import styled from "styled-components"
import { BUTTON_TYPE, BUTTON_VARIANTS, ICONS } from "@/constants"
import Button from "@/components/common/Buttons/Button"
import React from "react"
import Icon from "@/components/common/Icon/Icon"

const EmptyContent = styled.div`
	width: 100%;
	height: 100vh;
`

const ButtonWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	column-gap: 50px;
	justify-content: flex-start;
	align-items: center;
	padding: 50px 100px;
	position: relative;
	row-gap: 50px;
	background-color: ${({ theme }) => theme.colors.richBlack};
	border-top: 4px solid beige;

	h1 {
		position: absolute;
		top: 10px;
		left: 10px;
		color: beige;
	}

	&.rich-black {
		background-color: ${({ theme }) => theme.colors.richBlack};
	}

	&.rich-blue {
		background-color: ${({ theme }) => theme.colors.richBlue};
	}

	&.antiflash-white {
		background-color: ${({ theme }) => theme.colors.antiflashWhite};
	}

	&.white {
		background-color: ${({ theme }) => theme.colors.white};
	}

	&.chilli-red {
		background-color: ${({ theme }) => theme.colors.chilliRed};
	}
`
const ButtonIconWrapper = styled.div`
	height: 24px;
	width: 24px;
`

const ButtonsWrapper = styled.div`
	width: 100%;
	padding-top: 200px;
`

export default function PreviewPage() {
	const classes = ["rich-black", "antiflash-white", "chilli-red", "white", "rich-blue"]
	return (
		<>
			<ButtonsWrapper>
				{classes.map((item) => (
					<ButtonWrapper key={item} className={`main ${item}`}>
						<h1 className={"typo-borna typo-borna-11"}>{item}</h1>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.PRIMARY}>
							Przycisk testowy PRIMARY
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.PRIMARY}>
							Przycisk testowy PRIMARY
							<ButtonIconWrapper>
								<Icon name={ICONS.BURGER} />
							</ButtonIconWrapper>
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.SECONDARY}>
							Przycisk testowy SECONDARY
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.SECONDARY}>
							Przycisk testowy SECONDARY
							<ButtonIconWrapper>
								<Icon name={ICONS.BURGER} />
							</ButtonIconWrapper>
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.TERTIARY}>
							Przycisk testowy TERTIARY
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.TERTIARY}>
							Przycisk testowy TERTIARY
							<ButtonIconWrapper>
								<Icon name={ICONS.BURGER} />
							</ButtonIconWrapper>
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.QUATERNARY}>
							Przycisk testowy QUATERNARY
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.QUATERNARY}>
							Przycisk testowy QUATERNARY
							<ButtonIconWrapper>
								<Icon name={ICONS.BURGER} />
							</ButtonIconWrapper>
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.QUINARY}>
							Przycisk testowy QUINARY
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.QUINARY}>
							Przycisk testowy QUINARY
							<ButtonIconWrapper>
								<Icon name={ICONS.BURGER} />
							</ButtonIconWrapper>
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.SENARY}>
							Przycisk testowy SENARY
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.SENARY}>
							Przycisk testowy SENARY
							<ButtonIconWrapper>
								<Icon name={ICONS.BURGER} />
							</ButtonIconWrapper>
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.SEPTENARY}>
							Przycisk testowy SEPTENARY
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.SEPTENARY}>
							Przycisk testowy SEPTENARY
							<ButtonIconWrapper>
								<Icon name={ICONS.BURGER} />
							</ButtonIconWrapper>
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.PRIMARY}>
							Krotki
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.SECONDARY}>
							Krotki{" "}
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.TERTIARY}>
							Krotki
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.QUATERNARY}>
							Krotki
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.QUINARY}>
							Krotki
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.SENARY}>
							Krotki
						</Button>
						<Button type={BUTTON_TYPE.ANIMATED} variant={BUTTON_VARIANTS.SEPTENARY}>
							Krotki
						</Button>
					</ButtonWrapper>
				))}
			</ButtonsWrapper>
			{/*<StyledTypographyContainer>*/}
			{/*	<Container type="main">*/}
			{/*		<h1>Design Tokens</h1>*/}
			{/*	</Container>*/}
			{/*	<Container className="main">*/}
			{/*		<StyledContainerTester className="black">black</StyledContainerTester>*/}
			{/*		<StyledContainerTester className="white">white</StyledContainerTester>*/}
			{/*		<StyledContainerTester className="grey">grey</StyledContainerTester>*/}
			{/*		<StyledContainerTester className="darkBlue">darkBlue</StyledContainerTester>*/}
			{/*		<StyledContainerTester className="darkDarkBlue">darkDarkBlue</StyledContainerTester>*/}
			{/*		<StyledContainerTester className="blue">blue</StyledContainerTester>*/}
			{/*		<StyledContainerTester className="red">red</StyledContainerTester>*/}
			{/*		<StyledContainerTester className="darkRed">darkRed</StyledContainerTester>*/}
			{/*		<StyledContainerTester className="darkDarkRed">darkDarkRed</StyledContainerTester>*/}
			{/*		<StyledContainerTester className="darkDarkDarkRed">darkDarkDarkRed</StyledContainerTester>*/}
			{/*		<StyledContainerTester className="lavenda">lavenda</StyledContainerTester>*/}
			{/*		<StyledContainerTester className="darkLavenda">darkLavenda</StyledContainerTester>*/}
			{/*		<StyledContainerTester className="darkGrey">darkGrey</StyledContainerTester>*/}
			{/*	</Container>*/}
			{/*	<Container type="main">*/}
			{/*		<h1>Typography</h1>*/}
			{/*		<h3>Borna</h3>*/}
			{/*		<p className="typo-borna typo-borna-00">typo-borna-00 regular: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-00i">typo-borna-00i regular italic: Pójdźmyż haftnąć*/}
			{/*			z wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-01">typo-borna-01 medium: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-01i">typo-borna-01i medium italic: Pójdźmyż haftnąć*/}
			{/*			z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-02">typo-borna-02 semibold: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-02i">typo-borna-02i semibold italic: Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-03">typo-borna-03 bold: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-03i">typo-borna-03i bold italic: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-08">typo-borna-08 bold: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-08i">typo-borna-08i bold italic: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-17">typo-borna-17 bold: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-17i">typo-borna-17i bold italic: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-18">typo-borna-18 bold: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-18i">typo-borna-18i bold italic: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-19">typo-borna-19 bold: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-19i">typo-borna-19i bold italic: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-20">typo-borna-20 bold: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<p className="typo-borna typo-borna-20i">typo-borna-20i bold italic: Pójdźmyż haftnąć z*/}
			{/*			wklęsłości*/}
			{/*			guberń.</p>*/}
			{/*		<h3>Strawford</h3>*/}
			{/*		<p className="typo-strawford typo-strawford-00">typo-strawford-00 thin: Pójdźmyż haftnąć*/}
			{/*			z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-00i">typo-strawford-00i thin italic:*/}
			{/*			Pójdźmyż haftnąć*/}
			{/*			z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-01">typo-strawford-01 extralight: Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-01i">typo-strawford-01i extralight italic:*/}
			{/*			Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-02">typo-strawford-02 light: Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-02i">typo-strawford-02i light italic:*/}
			{/*			Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-03">typo-strawford-03 regular: Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-03i">typo-strawford-03i regular italic:*/}
			{/*			Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-04">typo-strawford-04 medium: Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-04i">typo-strawford-04i medium italic:*/}
			{/*			Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-05">typo-strawford-05 bold: Pójdźmyż haftnąć*/}
			{/*			z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-05i">typo-strawford-05i bold italic:*/}
			{/*			Pójdźmyż haftnąć*/}
			{/*			z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-06">typo-strawford-06 black: Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-06i">typo-strawford-06i black italic:*/}
			{/*			Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-07">typo-strawford-07 extralight: Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-07i">typo-strawford-07i extralight italic:*/}
			{/*			Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-09">typo-strawford-09 extralight: Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-09i">typo-strawford-09i extralight italic:*/}
			{/*			Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-15">typo-strawford-15 extralight: Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-15i">typo-strawford-15i extralight italic:*/}
			{/*			Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-16">typo-strawford-16 extralight: Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*		<p className="typo-strawford typo-strawford-16i">typo-strawford-16i extralight italic:*/}
			{/*			Pójdźmyż*/}
			{/*			haftnąć z*/}
			{/*			wklęsłości guberń.</p>*/}
			{/*	</Container>*/}
			{/*	<Container type="main">*/}
			{/*		<h1>Components</h1>*/}
			{/*	</Container>*/}
			{/*	<Container type="main">*/}
			{/*		<h3>Rodzaje kontenerów</h3>*/}
			{/*	</Container>*/}
			{/*	<Container type="full">*/}
			{/*		<StyledContainerTester className="darkRed">full</StyledContainerTester>*/}
			{/*	</Container>*/}
			{/*	<Container type="main">*/}
			{/*		<StyledContainerTester className="darkRed">main</StyledContainerTester>*/}
			{/*	</Container>*/}
			{/*	<Container type="narrow">*/}
			{/*		<StyledContainerTester className="darkRed">narrow</StyledContainerTester>*/}
			{/*	</Container>*/}
			{/*	<Container type="main">*/}
			{/*		<h1>Gridy</h1>*/}
			{/*	</Container>*/}
			{/*	<Container type="main">*/}
			{/*		<h3>Grid 16 columns</h3>*/}
			{/*	</Container>*/}
			{/*	<GridContainer>*/}
			{/*		<StyledContainerTester className="darkRed col-4">w-4-col</StyledContainerTester>*/}
			{/*	</GridContainer>*/}
			{/*	<GridContainer>*/}
			{/*		<StyledContainerTester className="darkRed col-8">w-8-col</StyledContainerTester>*/}
			{/*	</GridContainer>*/}
			{/*	<GridContainer>*/}
			{/*		<StyledContainerTester className="darkRed col-12">w-12-col</StyledContainerTester>*/}
			{/*	</GridContainer>*/}
			{/*	<GridContainer style={{marginBottom: '50px'}}>*/}
			{/*		<StyledContainerTester className="darkRed col-16">w-16-col</StyledContainerTester>*/}
			{/*	</GridContainer>*/}
			{/*	<Container type="main">*/}
			{/*		<h3>Uklad testowy</h3>*/}
			{/*	</Container>*/}
			{/*	<GridContainer style={{marginBottom: '50px'}}>*/}
			{/*		<StyledContainerTester className="blue col-1">news</StyledContainerTester>*/}
			{/*		<StyledContainerTester style={{ gridColumnStart: 15, gridColumnEnd: 17 }} className="blue col-4">button</StyledContainerTester>*/}
			{/*	</GridContainer>*/}
			{/*	<GridContainer style={{marginBottom: '50px'}}>*/}
			{/*		<StyledContainerTester className="height blue col-4">obrazek</StyledContainerTester>*/}
			{/*		<StyledContainerTester style={{ gridColumnStart: 6, gridColumnEnd: 7 }} className="blue col-1">data</StyledContainerTester>*/}
			{/*		<StyledContainerTester style={{ gridColumnStart: 9, gridColumnEnd: 14 }} className="blue col-8">tekst</StyledContainerTester>*/}
			{/*	</GridContainer>*/}
			{/*	<Container type="main">*/}
			{/*		<h3>Grid niestandardowy</h3>*/}
			{/*	</Container>*/}
			{/*	<GridContainer>*/}
			{/*		<StyledContainerTester style={{ gridColumnStart: 4, gridColumnEnd: 10 }} className="blue">od 4 do 9 kolumny</StyledContainerTester>*/}
			{/*		<StyledContainerTester style={{ gridColumnStart: 2, gridColumnEnd: 12 }} className="blue">od 2 do 11 kolumny</StyledContainerTester>*/}
			{/*		<StyledContainerTester style={{ gridColumnStart: 9, gridColumnEnd: 16 }} className="blue">od 9 do 15 kolumny</StyledContainerTester>*/}
			{/*	</GridContainer>*/}
			{/*	<GridContainer className='fixed-tester'>*/}
			{/*		{Array.from(Array(16).keys()).map((el, key) => <StyledContainerTester key={key} className="darkRed col-1">{`col-${key+1}`}</StyledContainerTester>)}*/}
			{/*	</GridContainer>*/}
			{/*	<Container type="main">*/}
			{/*		<h3>Grid 5 columns</h3>*/}
			{/*	</Container>*/}
			{/*	<GridContainerFiveColumns>*/}
			{/*		<StyledContainerTester className="blue border col-1">1 column width</StyledContainerTester>*/}
			{/*	</GridContainerFiveColumns>*/}
			{/*	<GridContainerFiveColumns>*/}
			{/*		<StyledContainerTester className="blue border col-2">2 columns width</StyledContainerTester>*/}
			{/*	</GridContainerFiveColumns>*/}
			{/*	<GridContainerFiveColumns>*/}
			{/*		<StyledContainerTester className="blue border col-3">3 columns width</StyledContainerTester>*/}
			{/*	</GridContainerFiveColumns>*/}
			{/*	<GridContainerFiveColumns>*/}
			{/*		<StyledContainerTester className="blue border col-4">4 columns width</StyledContainerTester>*/}
			{/*	</GridContainerFiveColumns>*/}
			{/*	<GridContainerFiveColumns>*/}
			{/*		<StyledContainerTester className="blue border col-5">5 columns width</StyledContainerTester>*/}
			{/*	</GridContainerFiveColumns>*/}
			{/*	<GridContainerFiveColumns className='fixed-tester'>*/}
			{/*		{Array.from(Array(5).keys()).map((el, key) => <StyledContainerTester key={key} className="border darkRed col-1">{`col-${key+1}`}</StyledContainerTester>)}*/}
			{/*	</GridContainerFiveColumns>*/}
			{/*	<Container type="main">*/}
			{/*		<h3>Układ grida 5 kolumn</h3>*/}
			{/*	</Container>*/}
			{/*	<GridContainerFiveColumns>*/}
			{/*		<StyledContainerTester className="red-square darkRed col-2">polski czerwony krzyz w swej działalności kieruje się zasadami międzynarodowego prawa humanitarnego oraz podstawowymi zasadami ruchu, którymi są:</StyledContainerTester>*/}
			{/*		<StyledContainerTester style={{ gridColumnStart: 3, gridColumnEnd: 4 }} className="bottom-square col-1">bezstronność</StyledContainerTester>*/}
			{/*		<StyledContainerTester style={{ gridColumnStart: 4, gridColumnEnd: 5 }} className="top-square col-1">Humanitaryzm</StyledContainerTester>*/}
			{/*		<StyledContainerTester style={{ gridColumnStart: 5, gridColumnEnd: 6 }} className="bottom-square col-1">Neutralnosc</StyledContainerTester>*/}
			{/*	</GridContainerFiveColumns>*/}
			{/*</StyledTypographyContainer>*/}
			<EmptyContent />
		</>
	)
}
